import { useEffect, useState } from "react";

export interface SSETick {
  ts: number;
}

// useSSE wraps EventSource and returns the most recent parsed payload
// plus a connected flag. The dashboard uses this to show "last tick Xs
// ago" so the operator can tell at a glance whether the pipeline is
// still alive.
export function useSSE(url: string): {
  tick: SSETick | null;
  connected: boolean;
} {
  const [tick, setTick] = useState<SSETick | null>(null);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    const es = new EventSource(url);
    es.onopen = () => setConnected(true);
    es.onerror = () => setConnected(false);
    es.onmessage = (ev) => {
      try {
        setTick(JSON.parse(ev.data) as SSETick);
      } catch {
        // malformed, ignore — next tick will retry
      }
    };
    return () => es.close();
  }, [url]);

  return { tick, connected };
}
